import {Visibility, VisibilityOff} from '@mui/icons-material'
import {IconButton, InputAdornment, TextField} from '@mui/material'
import {inputHeight} from 'appearance/theme'
import {useState} from 'react'
import {useI18n} from 'store/Store'

const Input = ({
    label,
    onChange,
    value,
    placeholder,
    initialValue = '',
    required,
    disabled,
    readOnly,
    error,
    name,
    type,
    fullWidth,
    inputProps,
    InputProps,
    inputStyle,
    multiline,
    minRows,
    maxRows,
    ...props
}) => {
    const {i18n} = useI18n()
    const [showPassword, setShowPassword] = useState(false)

    const handleMouseDownPassword = (event) => {
        event.preventDefault()
    }

    const showPasswordToggle = type === 'password'

    const passwordAdornment = createPasswordAdornment({
        enabled: showPasswordToggle,
        showPassword,
        setShowPassword,
        handleMouseDownPassword,
    })

    const combinedInputProps = composeInputProps({
        InputProps,
        multiline,
        passwordAdornment,
    })

    return (
        <TextField
            onChange={onChange}
            value={value || initialValue}
            fullWidth={fullWidth}
            label={label}
            placeholder={placeholder}
            required={required}
            disabled={disabled}
            type={showPassword ? 'text' : type}
            inputProps={{...inputProps, readOnly, style: inputStyle}}
            error={!!error}
            helperText={error && i18n.t(`formErrors.${error}`)}
            FormHelperTextProps={{
                error: !!error,
            }}
            InputLabelProps={{shrink: true}}
            InputProps={combinedInputProps}
            multiline={multiline}
            minRows={multiline ? minRows : undefined}
            maxRows={multiline ? maxRows : undefined}
            {...props}
        />
    )
}
export default Input

function createPasswordAdornment({
    enabled,
    showPassword,
    setShowPassword,
    handleMouseDownPassword,
}) {
    if (!enabled) {
        return undefined
    }

    return (
        <InputAdornment position="end">
            <IconButton
                aria-label="toggle password visibility"
                onClick={() => setShowPassword((show) => !show)}
                onMouseDown={handleMouseDownPassword}
                edge="end">
                {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
        </InputAdornment>
    )
}

function composeInputProps({InputProps, multiline, passwordAdornment}) {
    const baseStyle = InputProps?.style || {}
    const heightStyle = multiline ? {} : {height: inputHeight}

    return {
        ...InputProps,
        style: {...baseStyle, ...heightStyle},
        ...(passwordAdornment && {endAdornment: passwordAdornment}),
    }
}
